import { ClipboardCheck, Bell, FolderLock, Wrench, BookOpen, Globe } from 'lucide-react';
import AnimateIn from './AnimateIn';

const features = [
  {
    icon: ClipboardCheck,
    title: 'Compliance Checklists',
    desc: 'Step-by-step guidance to help you understand what documents and actions are required for your tenancy.',
  },
  {
    icon: Bell,
    title: 'Reminders & Expiry Tracking',
    desc: 'Never miss a deadline. Get timely reminders for document renewals, inspections, and key dates.',
  },
  {
    icon: FolderLock,
    title: 'Document Vault',
    desc: 'Store and organise tenancy documents securely in one place. Access them whenever you need.',
  },
  {
    icon: Wrench,
    title: 'Repair & Issue Tracking',
    desc: 'Log repairs and maintenance issues with photos, dates, and status updates for a clear record.',
  },
  {
    icon: BookOpen,
    title: 'Rights & Guidance Library',
    desc: 'Clear, date-aware information on landlord obligations and tenant rights in plain English.',
  },
  {
    icon: Globe,
    title: 'Multilingual Support',
    desc: 'Access guidance and workflows in multiple languages to support diverse households.',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" data-testid="features-section" className="py-20 sm:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <AnimateIn>
          <div className="text-center mb-14">
            <span className="inline-block text-compliance-green font-body font-semibold text-sm tracking-wide uppercase mb-3">
              Features
            </span>
            <h2 className="font-heading font-bold text-3xl sm:text-4xl text-ink mb-4">
              Everything you need, right on your phone
            </h2>
            <p className="text-slate-text font-body text-lg max-w-2xl mx-auto">
              ActCheck gives landlords and tenants the tools to stay organised, informed, and protected.
            </p>
          </div>
        </AnimateIn>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((f, i) => (
            <AnimateIn key={f.title} delay={i * 80}>
              <div
                data-testid={`feature-card-${i}`}
                className="group relative bg-mist rounded-2xl p-7 hover:bg-white hover:shadow-lg hover:shadow-navy/5 border border-transparent hover:border-gray-100 transition-all duration-300 hover:-translate-y-1 h-full"
              >
                <div className="w-12 h-12 rounded-xl bg-white group-hover:bg-compliance-green/10 flex items-center justify-center mb-5 transition-colors duration-300 shadow-sm">
                  <f.icon size={24} className="text-compliance-green" />
                </div>
                <h3 className="font-heading font-bold text-lg text-ink mb-2">{f.title}</h3>
                <p className="font-body text-sm text-slate-text leading-relaxed">{f.desc}</p>
              </div>
            </AnimateIn>
          ))}
        </div>
      </div>
    </section>
  );
}
